import { render, staticRenderFns } from "./KitchenAppliances.vue?vue&type=template&id=67183afe&scoped=true&"
import script from "./KitchenAppliances.vue?vue&type=script&lang=js&"
export * from "./KitchenAppliances.vue?vue&type=script&lang=js&"
import style0 from "./KitchenAppliances.vue?vue&type=style&index=0&id=67183afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67183afe",
  null
  
)

export default component.exports